// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__2A6nk","radioRow":"SimpleQuestionBuilderModal_radioRow__36jHj"};